import React from 'react';
import ReactTooltip from 'react-tooltip';
import Questionmark from '../../assets/img/question-mark.svg';

export default function TooltipCheckoutSidebar({ place = 'right', classAdded }) {
  return (
    <>
      <img
        data-event="click"
        className={`k-tooltip-icon ${classAdded}`}
        data-tip
        data-for="checkoutSidebar"
        role="tooltip"
        src={Questionmark}
        alt="Tooltip Due Today"
      />
      <ReactTooltip
        globalEventOff="click"
        clickable
        className="k-tooltip-theme"
        data-html
        id="checkoutSidebar"
        place={place}
        effect="solid"
      >
        <div className="k-checkout-tooltip">
          With each lease cycle, you will have the option to continue leasing, return your items, or pay off your full
          term. Your total lease-to-own cost can be more than two times the total retailer cash price depending on where
          you reside. See the lease disclosure for more details.
        </div>
      </ReactTooltip>
    </>
  );
}
